export default __webpack_public_path__ + "26d2b3c858bccaa5d7d2bf63d9697649.png";